module.exports = __webpack_public_path__ + "static/media/Kissen_50x50_rueckseite.226c1b08.png";